<template>
  <MaskLayer>
    <b-spinner
      variant="success"
      label="Spinning"
    />
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';

export default {
  components: {
    MaskLayer,
  },
};
</script>
